<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">

      <md-card>
        <md-card-header class="md-card-header-icon "  :class="{'md-card-header-danger': !user.active_account, 'md-card-header-green': user.active_account}">
          <div class="card-icon">
            <md-icon>{{ user.active_account ? 'person' : 'person_off' }}</md-icon>
          </div>
          <h4 class="title">
            User Profile
          </h4>
          <h4 class="title">{{ user.name? user.name:'User'}}  Details
            <div class="text-right">
              <md-button @click="toggleUserLock" class="md-primary md-dense">
                <md-icon>{{ user.active_account ? 'lock' : 'lock_open' }}</md-icon>
                <span class="action-label">{{ user.active_account ? 'Lock' : 'Unlock' }}</span>
              </md-button>

              <md-button @click="goToEdit(user.id)" class="md-primary md-dense">
                <md-icon>edit</md-icon>
                Edit User
              </md-button>
              <md-button @click="goBack" class="md-primary md-dense">Back to List</md-button>
            </div>
          </h4>
        </md-card-header>
        <md-card-content>
          <div>
            <div class="md-layout">
              <div class="md-layout-item md-size-30 md-small-size-100">
                <div class="picture-container">
                  <div class="picture">
                    <img :src="user.avatar_url" alt="user image">
                  </div>
                  <h6 class="description">Choose Picture</h6>
                </div>
              </div>
              <div class="md-layout-item md-size-70 mt-4 md-small-size-100">
                <md-card-content>
                  <items-view>
                    <item-view label="User Name" :value="user.name"></item-view>
                    <item-view label="User Email" :value="user.email"></item-view>
                    <item-view label="User Type" :value="user.model_type"></item-view>
                    <item-view label="Phone Number" :value="user.phone_number"></item-view>
                    <item-view label="Roles Count" :value="user.roles.length+''"></item-view>
                    <item-view label="All Permission Count" :value="user.allPermissions.length+''"></item-view>
                    <item-view label="Special Permission Count" :value="user.permissions.length+''"></item-view>
                    <item-view v-if="user.model" label="Institution"
                               :value="user.model.institution_name"></item-view>
                  </items-view>
                </md-card-content>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <div class="md-layout">

      <div class="md-layout-item">
        <md-card-content>
          <nav-tabs-card>
            <template slot="content">
              <md-tabs class="md-info md-white" md-alignment="left">
                <md-tab id="tab-users" md-label="Role List" md-icon="supervisor_account">
                  <md-button class="md-primary md-raised"
                             @click="showRoleModal">
                    Assign Role to {{ user.name }}
                  </md-button>
                  <user-role-table :tableData="user.roles"
                                   :user="user"
                                   @removeRole="deleteRoleRow"
                                   @addRoleToUser="showRoleModal"
                                   @searchUserTable="searchOnUserTables"
                  ></user-role-table>

                </md-tab>
                <md-tab id="tab-home" md-label="Permission List" md-icon="lock">
                  <md-button class="md-primary md-raised"
                             @click="showPermissionModal">
                    Assign Permission to {{ user.name }}
                  </md-button>
                  <user-permissions-table :tableData="user.allPermissions"
                                          :user="user"
                                          @removePermission="deletePermissionRow"
                                          @editRole="goToEdit"
                                          @addPermissionToUser="addPermissions"
                  ></user-permissions-table>
                </md-tab>
                <md-tab id="tab-password" md-label="Change Password" md-icon="lock">
                  <reset-password-card :user="user"
                                       :is-admin="true"
                                       :is-admin-reset="true"
                                       @success="onPasswordReset"></reset-password-card>
                </md-tab>
              </md-tabs>
            </template>
          </nav-tabs-card>

          <add-permission-modal
              :title="'Add Permission to '+user.name"
              :showModal="showPermissionForm"
              @closeModal="hidePermissionModal"
              @addPermissions="addPermissions"
          ></add-permission-modal>
          <add-role-modal
              :title="'Add Role to '+user.name"
              :showModal="showRoleForm"
              @closeModal="hideRoleModal"
              @addRoles="addRoles"
          ></add-role-modal>
          <!-- Lock/Unlock Confirmation Dialog -->
          <md-dialog :md-active.sync="showLockDialog" class="lock-dialog">
            <md-dialog-title>
              {{ user.active_account ? 'Lock User' : 'Unlock User' }}
            </md-dialog-title>
            <md-dialog-content>
              <div class="dialog-content">
                <md-icon class="dialog-icon" :class="{'warning': user.active_account, 'success': !user.active_account}">
                  {{ user.active_account ? 'lock' : 'lock_open' }}
                </md-icon>
                <p>
                  {{
                    !user.active_account
                        ? 'Are you sure you want to unlock this user account? The user will be able to log in again.'
                        : 'Are you sure you want to lock this user account? The user will not be able to log in.'
                  }}
                </p>
                <md-field>
                  <label>Reason (Optional)</label>
                  <md-textarea v-model="lockReason" rows="2"
                               placeholder="Provide a reason for this action..."></md-textarea>
                </md-field>
              </div>
            </md-dialog-content>
            <md-dialog-actions>
              <md-button class="md-primary" @click="confirmToggleLock" :disabled="isProcessing">
                {{ isProcessing ? 'Processing...' : (!user.active_account ? 'Unlock' : 'Lock') }}
              </md-button>
              <md-button class="md-danger" @click="showLockDialog = false">Cancel</md-button>
            </md-dialog-actions>
          </md-dialog>
        </md-card-content>
      </div>
    </div>
  </div>
</template>
<script>
import {AddPermissionModal, AddRoleModal, NavTabsCard} from '@/components';
import ItemsView from '../../../../components/Inputs/ItemsView';
import ItemView from '../../../../components/Inputs/ItemView';
import formMixin from '@/mixins/form-mixin';
import UserRoleTable from '../../../../components/Tables/UserRoleTable';
import Swal from 'sweetalert2';
import UserPermissionsTable from '../../../../components/Tables/UserPermissionsTable';
import ResetPasswordCard from "@/pages/Dashboard/Examples/UserProfile/ResetPasswordCard.vue";


const toLower = text => {
  return text.toString().toLowerCase();
};
const searchByName = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.name).includes(toLower(term)));
  }
  return items;
};
export default {
  components: {
    ResetPasswordCard,
    UserPermissionsTable,
    AddPermissionModal,
    UserRoleTable,
    AddRoleModal,
    ItemView,
    ItemsView,
    NavTabsCard
  },
  mixins: [formMixin],
  data() {
    return {
      user: {
        permissions: [],
        allPermissions: [],
        roles: [],
        active_account: false,
        is_online: false,
        last_login_at: null,
        last_login_ip: null,
        two_factor_enabled: false
      },
      roles: [],
      permissions: [],
      showPermissionForm: false,
      showRoleForm: false,
      showLockDialog: false,
      lockReason: '',
      isProcessing: false,
      searchedUsers: [],
      roleData: [],
      defaultAvatar: '/img/default-avatar.png'
    };
  },
  created() {
    this.get();
  },
  computed: {
    shoppingTotal() {
      return this.shoppingCartTable.reduce((accumulator, current) => {
        return accumulator + current.amount;
      }, 0);
    }
  },
  methods: {
    async get() {
      try {
        const id = this.$route.params.id;
        let params = {
          id: id,
          include: 'roles,permissions,model.vendor,model.department.station'
        };
        await this.$store.dispatch('users/get', params);
        this.user = this.$store.getters['users/user'];
        this.user.active_account = this.user.active_account || false;

        const ids = this.user.id;
        await this.$store.dispatch('permissions/list', ids);
        this.permissions = this.$store.getters['permissions/list'];
        this.userData = this.user.roles;
        this.searchedUsers = this.userData;
      } catch (e) {
        this.notifyException(e)
        this.notifyError('Oops, something went wrong!')
      }
    },
    toggleUserLock() {
      this.lockReason = '';
      this.showLockDialog = true;
    },


    async confirmToggleLock() {
      this.isProcessing = true;
      try {
        const payload = {
          user_id: this.user.id,
          locked: !this.user.active_account,
          reason: this.lockReason
        };

        this.user.active_account = !this.user.active_account;
        this.user.lock_reason = this.lockReason;
        await this.$store.dispatch('users/update', this.user);
        this.notifySuccess(!this.user.active_account ? 'User account locked successfully' : 'User account unlocked successfully');
        this.showLockDialog = false;

      } catch (error) {
        this.user.active_account=!this.user.active_account
        console.error('Toggle lock error:', error);
        this.notifyError('Failed to update user status');
        this.notifyException(error);
      } finally {
        this.isProcessing = false;
      }
    },

    goBack() {
      this.$router.push({name: 'List Users'});
    },
    goToEditPermission(id) {
      this.$router.push({name: 'Edit Permission', params: {id}});
    },
    getToViewPermission(id) {
      this.$router.push({name: 'View Permission', params: {id}});
    },
    deletePermissionRow(item) {
      let indexToDelete = this.user.permissions.findIndex(
          tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.user.permissions.splice(indexToDelete, 1);
        this.update();
      }
    },
    showPermissionModal() {
      this.showPermissionForm = true;
    },
    hidePermissionModal() {
      this.showPermissionForm = false;
    },
    async addPermissions(new_permission) {
      try {
        let permissionIds = this.user.permissions.map(p => p.id);
        let updateNeeded = false;
        new_permission.forEach(permission => {
          if (!permissionIds.includes(permission.id)) {
            this.user.permissions.push(permission);
            updateNeeded = true;
          } else {
            this.$store.dispatch(
                'alerts/error',
                `Oops, Permision for ${permission.name} already on list!`
            );
          }
        });
        if (updateNeeded) {
          await this.update();
        }

        this.hidePermissionModal();
        this.new_permission = [];
      } catch (e) {
        await this.$store.dispatch(
            'alerts/error',
            'Oops, something went wrong!'
        );
      }
    },
    removeUserFromRole(item) {
      Swal.fire({
        title: 'Are you sure?',
        text: `Remove user '${item.name}' from role ${this.role.name}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteUserRow(item);
          Swal.fire({
            title: 'Deleted!',
            text: `You remove user '${item.name}'`,
            icon: 'success',
            confirmButtonClass: 'md-button md-success btn-fill',
            buttonsStyling: false
          });
        }
      });
    },
    deleteUserRow(item) {
      let indexToDelete = this.role.users.findIndex(
          tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.role.users.splice(indexToDelete, 1);
        this.update();
        this.searchedUsers = this.role.users;
      }
    },
    async update() {
      try {
        await this.$store.dispatch('users/update', this.user);
        await this.$store.dispatch(
            'alerts/success',
            'User updated successfully.'
        );
      } catch (e) {
        if (e.response.data.errors[0]) {
          await this.$store.dispatch(
              'alerts/error',
              e.response.data.errors[0].title
          );
          this.setApiValidation(e.response.data.errors);
        } else {
          await this.$store.dispatch(
              'alerts/error',
              'Oops, something went wrong!'
          );
        }
      }
    },
    deleteRoleRow(item) {
      let indexToDelete = this.user.roles.findIndex(
          tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.user.roles.splice(indexToDelete, 1);
        this.update();
      }
    },
    showRoleModal() {
      this.showRoleForm = true;
    },
    hideRoleModal() {
      this.showRoleForm = false;
    },
    async addRoles(new_role) {
      try {
        let roleIds = this.user.roles.map(p => p.id);
        let updateNeeded = false;
        new_role.forEach(role => {
          if (!roleIds.includes(role.id)) {
            this.user.roles.push(role);
            updateNeeded = true;
          } else {
            this.$store.dispatch(
                'alerts/error',
                `Oops, Role for ${role.name} already on list!`
            );
          }
        });
        if (updateNeeded) {
          await this.update();
        }

        this.hideRoleModal();
        this.new_permission = [];
      } catch (e) {
        console.log(e);
        await this.$store.dispatch(
            'alerts/error',
            'Oops, something went wrong!'
        );
      }
    },
    goToEdit(id) {
      this.$router.push({name: 'Edit User', params: {id}});
    },
    onSelect: function (items) {
      this.selected = items;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    onPasswordReset() {
      this.notifySuccess('Password updated successfully')
    },

    searchOnUserTables(searchKey) {
      this.searchedUsers = searchByName(this.userData, searchKey);
    },

  }
};
</script>
<style lang="scss" scoped>
.text-right .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}

.md-table .md-table-head:last-child {
  text-align: right;
}

.table-stats {
  display: flex;
  align-items: center;
  text-align: right;
  flex-flow: row wrap;

  .td-price .td-total {
    display: inline-flex;
    font-weight: 500;
    font-size: 1.0625rem;
    margin-right: 50px;
  }

  &.table-striped .td-price {
    border-bottom: 0;
  }

  .td-price {
    font-size: 26px;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
  }

  .td-price,
  > div {
    flex: 0 0 100%;
    padding: 12px 8px;
  }
}

.table-shopping .md-table-head:nth-child(5),
.table-shopping .md-table-head:nth-child(7),
.table-shopping .md-table-head:nth-child(6) {
  text-align: right;
}
</style>
